export const USERS_READ_FROM_FORAGE = 'USERS_READ_FROM_FORAGE'
export const USERS_FORGET_USERS = 'USERS_FORGET_USERS'
export const USERS_LOGIN_USER = 'USERS_LOGIN_USER'
export const USERS_LOGOUT_USER = 'USERS_LOGOUT_USER'

export const USERS_CHANGED = 'USERS_CHANGED'
export const USERS_ADDED = 'USERS_ADDED'
export const USER_ADDED = 'USER_ADDED'



// WEBPACK FOOTER //
// ./src/features/Users/data/constants.js